export default __webpack_public_path__ + "static/char-s-62-kr-3df0ab76db3b0e5abda732d6d2b91c51.webp";